import axios from 'axios'
//constantes
const dataInicial = {
    datapercepcion: [{
        "idmovtopdo": " ",
        "idlote": " ",
        "idperiodo": 0,
        "idempleado": 0,
        "codigoempleado": " ",
        "nombrelargo": " ",
        "idconcepto": 0,
        "importetotal": 0
    }],
    datadeduccion: [{}],
    dataincidencias: [{}],
    datamovimientos: [{}],
}

//types
const OBTENER_PERCEPCION = 'OBTENER_PERCEPCION'
const OBTENER_DEDUCCION = 'OBTENER_DEDUCCION'
const OBTENER_INCIDENCIAS = 'OBTENER_INCIDENCIAS'
const OBTENER_MOVIMIENTOS = 'OBTENER_MOVIMIENTOS'

const { REACT_APP_API_URL } = process.env;
//reducer
export default function PdimIncidenciasMovReducer(state = dataInicial, action) {
    switch (action.type) {
        case OBTENER_PERCEPCION:
            return { ...state, datapercepcion: action.payload }
        case OBTENER_DEDUCCION:
            return { ...state, datadeduccion: action.payload }
        case OBTENER_INCIDENCIAS:
            return { ...state, dataincidencias: action.payload }
        case OBTENER_MOVIMIENTOS:
            return { ...state, datamovimientos: action.payload }
        default:
            return state
    }
}

//acciones
export const obtenermovpercepcion = (id) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')

    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const res = await axios.get(`${REACT_APP_API_URL}/pdim/percepcion?idmovtopdo=${id}`, requestOptions)
        dispatch({
            type: OBTENER_PERCEPCION,
            payload: res.data
        }
        )

    } catch (error) {
        console.log(error)
    }
}


export const obtenermovdeduccion = (id) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')

    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const res = await axios.get(`${REACT_APP_API_URL}/pdim/deduccion?idmovtopermanente=${id}`, requestOptions)
        dispatch({
            type: OBTENER_DEDUCCION,
            payload: res.data
        }
        )

    } catch (error) {
        console.log(error)
    }
}


export const obtenermovincidencias = (id) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')

    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const res = await axios.get(`${REACT_APP_API_URL}/pdim/incidencia?${id}`, requestOptions)
        dispatch({
            type: OBTENER_INCIDENCIAS,
            payload: res.data
        }
        )

    } catch (error) {
        console.log(error)
    }
}



export const obtenermovmov = (id) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')

    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const res = await axios.get(`${REACT_APP_API_URL}/pdim/movimiento?idmovimiento=${id}`, requestOptions)
        dispatch({
            type: OBTENER_MOVIMIENTOS,
            payload: res.data
        }
        )

    } catch (error) {
        console.log(error)
    }
}


